import { select, put, call } from 'redux-saga/effects';

import { get } from 'object-path';
import { isEmpty } from 'lodash';

import { getChatIdByPathname } from '../helpers/ChatUtils';
import * as actions from '../actions/chatActions';
import { REMOVE_MESSAGES, REMOVE_ATTACHMENTS } from '../constants/ActionTypes';
import { getIdentity } from './sendSagas';
import { logError } from '../helpers/BrowserUtils';

export function* syncData() {
  try {
    // Reload base application data that may have changed.
    yield call(getIdentity);
    yield put(actions.getAppStartData());

    // If we're currently in a chat, reload Messages for that chat.
    // Others will be reloaded when clicking on the chat.
    const pathname = yield select(state => get(state, 'router.location.pathname', ''));
    const chatId = getChatIdByPathname(pathname);
    if (chatId) {
      const localMessages = yield select(state => Object.values(state.messages).filter(message => message.isLocal));
      if (!isEmpty(localMessages)) {
        const localMessageIds = localMessages.map(message => message.id);
        yield put({ type: REMOVE_MESSAGES, payload: { messageIds: localMessageIds } });
      }

      const localAttachments = yield select(state => Object.values(state.attachments).filter(attachment => attachment.isLocal));
      if (!isEmpty(localAttachments)) {
        const localAttachmentIds = localAttachments.map(attachment => attachment.id);
        yield put({ type: REMOVE_ATTACHMENTS, payload: { attachmentIds: localAttachmentIds } });
      }

      yield put(actions.getMessages(chatId));
    }
  } catch (e) {
    logError('Failed to sync data', e);
  }
}
